import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=b4b930d6&scoped=true&"
import script from "./Banners.vue?vue&type=script&lang=ts&"
export * from "./Banners.vue?vue&type=script&lang=ts&"
import style0 from "./Banners.vue?vue&type=style&index=0&id=b4b930d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b930d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VImg,VProgressCircular})
